var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"id":`static-image-${_vm.config.categoryBlockId}`,"src":_vm.srcImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }